export default __webpack_public_path__ + "static/3-60576d5880fa359b1e3728630402a1b6.jpg";